define('bizzabo/models/Question',[
    'GSModel',
    'backbone-validation',
    'bizzabo/models/ValidationObject',
    'bizzabo/models/AnswersCollection',
    'bizzabo/models/SyncedModel'
], function(
    GSModel,
    BackboneValidation,
    ValidationObject,
    AnswersCollection,
    SyncedModel
    ) {

    var Question = SyncedModel.extend({

        defaults : {
            'type' : 'choices',
            'result-type' : 'percent',
            'show-results' : true
        },

        sync : function(method, model, options) {
            if (method == 'delete') {
                // Leave this empty in order to support local destroy() calls
            }
        },

        initialize : function(map) {
            if (map && map['choices']) {
                var newChoices = new AnswersCollection(map['choices']);
                this.set('choices', newChoices);
            }
            this.validationObject = new ValidationObject(this);
            this.bindToAnswersModel();
        },

        bindToAnswersModel : function() {
            if (this.get('choices')) {
                this.listenTo(this.get('choices'), 'change', this.triggerChange);
            }
        },

        isAllModelValid : function(validate) {
            var choices = this.get('choices');
            var isAnswerValid = true;
            if (this.get('type') !== 'text') {
                if (choices) {
                    choices.each(function(answer){
                        isAnswerValid = answer.isValid(validate) && isAnswerValid;
                    });
                }
            }
            return (this.isValid(validate) && isAnswerValid);
        },

        triggerChange : function(model) {
            this.wasEdited = true;
            this.trigger('change', model);
        },

        setAnswersIndices : function() {
            if (this.get('choices')) {
                this.get('choices').updateModelsIndex();
            }
        },

        validation : {
            'text' : [
                {
                    required : true,
                    msg : 'Question name is required'
                },
                {
                    maxLength : 140,
                    msg : 'Max. 140 characters'
                }
            ]
        }
    });

    return Question;

});
